export default __webpack_public_path__ + "static/media/background-texture.14e52f10.svg";